import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Tabs } from 'antd';

import '../../../../styles/pages/seller/_sellers.scss';

import { useState, useEffect } from 'react';
import DetailedInfo from '../../Detail/components/ForwarderInfo';
import ForwarederMsg from '../../Detail/components/ForwarderMsg';
import forwardingService from '../../services';
import { useParams } from 'react-router-dom';
const DetailedForwarder = () => {
  const { id } = useParams<{ id: string }>();
  const breadcrumbList = [
    { tittle: 'Seller', url: '' },
    { tittle: 'Seller message', url: '' }
  ];
  const [key, setKey] = useState('1');
  const [quotation, setQuotation] = useState<any>();
  const fetchData = async () => {
    const res = await forwardingService.getInboundDetail(id);
    setQuotation(res?.quotation);
  };
  useEffect(() => {
    fetchData();
  }, []);
  console.log(quotation);
  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />

      <div className="busk-tabs">
        {!!!quotation ? (
          <div className="busk-container">
            <ForwarederMsg />
          </div>
        ) : (
          <Tabs style={{ padding: 20 }} defaultActiveKey="1" onChange={setKey}>
            <Tabs.TabPane tab="Detailed Inbound" key="1">
              <DetailedInfo />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Message" key="2">
              <ForwarederMsg />
            </Tabs.TabPane>
          </Tabs>
        )}
      </div>
    </div>
  );
};

export default DetailedForwarder;
